var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#414141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7878 16L10.2511 11.4632C9.91632 11.1285 9.91632 10.5858 10.2511 10.2511C10.5858 9.91632 11.1285 9.91632 11.4632 10.2511L16 14.7878L20.5368 10.2511C20.8715 9.91632 21.4142 9.91632 21.7489 10.2511C22.0837 10.5858 22.0837 11.1285 21.7489 11.4632L17.2122 16L21.7489 20.5368C22.0837 20.8715 22.0837 21.4142 21.7489 21.7489C21.4142 22.0837 20.8715 22.0837 20.5368 21.7489L16 17.2122L11.4632 21.7489C11.1285 22.0837 10.5858 22.0837 10.2511 21.7489C9.91632 21.4142 9.91632 20.8715 10.2511 20.5368L14.7878 16Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloseIcon.eb156dd7bbbab6230a1a6e0b176821a9.svg";